export default __webpack_public_path__ + "static/media/icon-source.7c9bd388.svg";